import React from 'react'
import Certification from '../components/certificates'

const Certificates  = () => {
    return (
        <React.Fragment>
            <Certification />
        </React.Fragment>
    )
}

export default Certificates